// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"564":"bb83522a","601":"d5ff6488","757":"80136d6d","865":"2afef608","977":"eb726c9f"}[chunkId] + ".css";
};